import React, { createContext, useState } from 'react';


interface AttendanceSearchContextType {
    // searchValue:string,
    // searchField:string,
    statusValue: string,
    setAttendanceSearch: (field: string, value: string) => void;
}
interface AttendanceSearchProviderProps {
    children: React.ReactNode;
}
const initialValue: AttendanceSearchContextType = {
    // searchValue: '',
    // searchField: '',
    statusValue: '',
    setAttendanceSearch: () => {}
};



export const AttendanceSearchContext = createContext<AttendanceSearchContextType>(initialValue);

export function AttendanceSearchProvider({
                                             children,
                                         }: AttendanceSearchProviderProps){

    // const [searchValue, setSearchValue] = useState("");
    // const [searchField, setSearchField] = useState("");

    const [statusValue, setStatusValue] = useState("");

    function setAttendanceSearch(field: string, value: string) {
        // setSearchField(field);
        // setSearchValue(value);
        setStatusValue(value);
    }

    return (
        <AttendanceSearchContext.Provider  value={{
        // searchValue,
        //     searchField,
            statusValue,
            setAttendanceSearch,
    }}
>
    {children}
    </AttendanceSearchContext.Provider>
);
};
export default AttendanceSearchContext;
